import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const Settings = () => {
  const [form, setForm] = useState({ default_datacenter: 'nyc3', quota_limit: 5 });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`/api/settings`, { withCredentials: true });
      if (res.data) setForm(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`/api/settings`, form, { withCredentials: true });
      toast.success("Settings saved");
    } catch (e) {
      toast.error("Failed to save settings");
    }
  };

  return (
    <div className="space-y-8">
      <h1 className="text-4xl font-black">SETTINGS</h1>
      
      <div className="bg-card border border-white/10 p-8 max-w-xl">
        <form onSubmit={handleSave} className="space-y-6">
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-500 font-bold mb-2 block">Default Datacenter</label>
            <select 
              value={form.default_datacenter} 
              onChange={(e) => setForm({...form, default_datacenter: e.target.value})}
              data-testid="select-datacenter"
              className="w-full bg-[#0A0B0E] border border-white/10 p-3 text-white focus:outline-none focus:border-primary appearance-none rounded-none"
            >
              <option value="nyc3">NYC3 (New York)</option>
              <option value="sfo3">SFO3 (San Francisco 3)</option>
              <option value="sfo2">SFO2 (San Francisco 2)</option>
              <option value="tor1">TOR1 (Toronto)</option>
              <option value="lon1">LON1 (London)</option>
              <option value="ams3">AMS3 (Amsterdam)</option>
              <option value="fra1">FRA1 (Frankfurt)</option>
              <option value="atl1">ATL1 (Atlanta)</option>
              <option value="sgp1">SGP1 (Singapore)</option>
              <option value="syd1">SYD1 (Sydney)</option>
              <option value="blr1">BLR1 (Bangalore)</option>
            </select>
          </div>
          
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-500 font-bold mb-2 block">Spaces Quota per Datacenter/Account</label>
            <input 
              type="number" 
              min="1" 
              max="100"
              value={form.quota_limit} 
              onChange={(e) => setForm({...form, quota_limit: parseInt(e.target.value) || 5})}
              data-testid="input-quota"
              className="w-full bg-[#0A0B0E] border border-white/10 p-3 font-mono focus:outline-none focus:border-primary"
            />
            <p className="text-xs text-slate-500 mt-2 leading-relaxed">
              Default is 5 to prevent DigitalOcean 429 rate limit errors when creating multiple buckets back-to-back.
            </p>
          </div>

          <button 
            type="submit" 
            data-testid="save-settings-btn"
            className="bg-primary text-black font-bold py-3 px-8 uppercase tracking-wider hover:bg-[#00B8CC] transition-colors"
          >
            SAVE PREFERENCES
          </button>
        </form>
      </div>
    </div>
  );
};

export default Settings;